export default function SkeletonCard({ hero = false }) {
  return (
    <div
      className={`bg-white border border-slate-200 rounded-xl overflow-hidden ${hero ? "md:col-span-2 md:row-span-2" : ""}`}
      data-testid="skeleton-card"
    >
      <div className={`shimmer ${hero ? "aspect-[16/10]" : "aspect-[16/9]"}`} />
      <div className="p-5 space-y-3">
        <div className="shimmer h-3 w-24 rounded" />
        <div className="shimmer h-5 w-full rounded" />
        <div className="shimmer h-5 w-3/4 rounded" />
      </div>
    </div>
  );
}
